module.exports = __webpack_public_path__ + "img/baden_express_logo.bf4e036e.png";